/**
 * @file page entry
 * @author luohuixiang<luohuixiang@baidu.com>
 */

import 'babel-polyfill';
import Vue from 'vue';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import Loading from '@/directives/loading.js';
import Toast from '@/directives/toast.js';
import App from './app.vue';
import {performanceMonitor} from '@/utils/browser';
import logger from '@/plugins/logger';
import {getUserAgentInfo} from '@/utils/browser-info';
import {getFormatCookie} from '@/utils/experiment';
import {getQueryString} from '@/utils/url';
import initWeirwood from '@/utils/weirwood';
import VueLazyload from 'vue-lazyload';
import VueCompositionAPI from '@vue/composition-api';
import {SPECIAL_CHANNEL_MAP} from '@/common/js/Constant';
window.isSendWiseEndCount = false; // 是否发送了到达率打点
window.SpyIns = new window.SpyClient({pid: '13_96'});
const formatCookie = getFormatCookie();
window.onerror = function (url, line, col, err) {
    window.SpyIns.sendExceptForError(err, {
        group: 'gamepage-fe',
        info: {
            navigator: window.navigator,
            errUrl: url,
            errline: line,
            errCol: col,
        },
        dim: {
            page: 'newDetail',
        },
    });
};
window.onload = function () {
    if (!window.isSendWiseEndCount) {
        performanceMonitor('13_96', 'gamepage_detail_new');
        window.isSendWiseEndCount = true;
    }
};


window.detailUserAgentInfo = getUserAgentInfo();

let effectiveType = '';
if (navigator && navigator.connection && navigator.connection.effectiveType) {
    effectiveType = navigator.connection.effectiveType;
}
let loggerBody = {
    from: 'Mini_Swan_game',
    page: 'AldDetailPage',
    inBox: 0,
    network: effectiveType,
    'swan_name': 'baiduGame',
    styleInfo: formatCookie.GAME_SID_KEY || '',
    source: getQueryString('channelid') || '',
};

Vue.use(preview, {
    tapToClose: true,
    fullscreenEl: false,
});

Vue.use(Loading);
Vue.use(VueCompositionAPI);
Vue.use(Toast);
Vue.use(VueLazyload);
try {
    Vue.prototype.$wifi = (window.navigator.connection.effectiveType === 'wifi');
}
catch {
    Vue.prototype.$wifi = false;
}

Vue.use(logger, loggerBody);

document.title = '详情页';

initWeirwood(Vue);
Vue.config.productionTip = false;

export const eventBus = new Vue();

new Vue({
    data() {
        return {
            videoView: true,
            extData: {},
            isFromTiebaFeed: +getQueryString('channelid') === SPECIAL_CHANNEL_MAP.TIEBA_FEED,
        };
    },
    render: h => h(App),
}).$mount('#app');
